import React from "react"
import {
  referralStatusLabel,
  referralStatusTone,
  type ReferralDiscountRow,
} from "./referralDiscountUtils.ts"

type InvoiceReferralDiscountsProps = {
  rows?: ReferralDiscountRow[] | null
  referralDiscountTotal?: number
  preReferralTotal?: number
}

export function InvoiceReferralDiscounts({
  rows,
  referralDiscountTotal = 0,
  preReferralTotal,
}: InvoiceReferralDiscountsProps) {
  const visibleRows = (rows || []).filter((row) => row.eligibility_status !== "removed_manual")
  if (!visibleRows.length) return null

  return (
    <div className="border-b border-slate-100 py-6 sm:py-8">
      <p className="mb-3 text-xs font-bold uppercase tracking-widest text-slate-400">Referral discounts</p>
      <div className="overflow-hidden rounded-xl border border-slate-100">
        <table className="min-w-full text-sm">
          <thead className="bg-slate-50 text-left">
            <tr>
              <th className="px-4 py-2.5 text-[10px] font-bold uppercase tracking-widest text-slate-400">Referred customer</th>
              <th className="px-4 py-2.5 text-[10px] font-bold uppercase tracking-widest text-slate-400">Status</th>
              <th className="px-4 py-2.5 text-right text-[10px] font-bold uppercase tracking-widest text-slate-400">Discount</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100 bg-white">
            {visibleRows.map((row) => (
              <tr key={row.id || row.referred_customer_id}>
                <td className="px-4 py-3">
                  <p className="font-medium text-slate-800">{row.referred_customer_name || "Referred customer"}</p>
                  <p className="text-xs text-slate-500 font-mono">{row.referred_internet_id}</p>
                </td>
                <td className="px-4 py-3">
                  <span
                    className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${referralStatusTone(
                      row.eligibility_status,
                    )}`}
                  >
                    {referralStatusLabel(row.eligibility_status)}
                  </span>
                </td>
                <td className="px-4 py-3 text-right tabular-nums font-semibold text-emerald-700">
                  {row.eligibility_status === "eligible"
                    ? `- PKR ${Number(row.applied_discount_amount || 0).toLocaleString()}`
                    : "—"}
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot className="bg-slate-50">
            {typeof preReferralTotal === "number" ? (
              <tr>
                <td colSpan={2} className="px-4 py-2.5 text-xs font-medium text-slate-500">
                  Before referral discounts
                </td>
                <td className="px-4 py-2.5 text-right tabular-nums text-slate-700">
                  PKR {preReferralTotal.toLocaleString()}
                </td>
              </tr>
            ) : null}
            <tr>
              <td colSpan={2} className="px-4 py-3 text-sm font-semibold text-slate-700">
                Referral discount total
              </td>
              <td className="px-4 py-3 text-right tabular-nums text-sm font-bold text-emerald-700">
                - PKR {referralDiscountTotal.toLocaleString()}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  )
}
